<h4 class="t-large t-medium">{{ heading }}</h4>
<div class="menu-wrapper">
  @for (menu of menus; track menu) { @if (!isExternalUrl(menu.link)) {
  <a class="menu" [routerLink]="menu.link">{{ menu.text }}</a>
  } @if (isExternalUrl(menu.link)) {
  <a class="menu" [href]="menu.link">{{ menu.text }}</a>
  } }
</div>
